var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22580_256917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 21.6667H23.1111C23.6 21.6667 24 21.2667 24 20.7778C24 20.2889 23.6 19.8889 23.1111 19.8889H8.88889C8.4 19.8889 8 20.2889 8 20.7778C8 21.2667 8.4 21.6667 8.88889 21.6667ZM8.88889 17.2222H23.1111C23.6 17.2222 24 16.8222 24 16.3333C24 15.8444 23.6 15.4444 23.1111 15.4444H8.88889C8.4 15.4444 8 15.8444 8 16.3333C8 16.8222 8.4 17.2222 8.88889 17.2222ZM8 11.8889C8 12.3778 8.4 12.7778 8.88889 12.7778H23.1111C23.6 12.7778 24 12.3778 24 11.8889C24 11.4 23.6 11 23.1111 11H8.88889C8.4 11 8 11.4 8 11.8889Z",
    fill: "#4E5968"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22580_256917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.06136bc7011845efa7edeacd89be9217.svg";
export { ForwardRef as ReactComponent };